import { Schema } from '@rest-hooks/rest';
import { ScoreModel } from '../interfaces/scoreModel';
import { PolicyRuleResource } from './policyRuleResource';
import { BaseAuthenticationResource } from './BaseAuthenticationResource';

export class ScoreModelResource extends BaseAuthenticationResource implements ScoreModel {
  readonly scoreModelId: number = 0;
  readonly name: string = '';
  readonly active: boolean = false;
  readonly changedBy?: string = undefined;
  readonly changedDate?: Date = undefined;
  readonly policyRules: PolicyRuleResource[] = [];

  pk() {
    return `${this.scoreModelId}`;
  }
  static getEndpointExtra() {
    return {
      dataExpiryLength: 600000
    };
  }
  static urlRoot = '/api/scoremodels/';

  static schema: { [k: string]: Schema } = {
    policyRules: [PolicyRuleResource]
  };
}
